import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const loadProfileInfo = async (token, data) => {
  try {
    const res = await axios
      .post(`${VUE_APP_API_URL}/api/v2/getProfileInfo`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const updateProfileAddress = async (token, data) => {
  try {
    const res = await axios
      .post(`${VUE_APP_API_URL}/api/v2/updateProfileAddress`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const updateProfilePerson = async (token, data) => {
  try {
    const res = await axios
      .post(`${VUE_APP_API_URL}/api/v2/updateProfilePerson`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const nationalityIncorrectEmail = async (token, data) => {
  try {
    const res = await axios
      .post(`${VUE_APP_API_URL}/api/email`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

export {
  loadProfileInfo, updateProfileAddress, updateProfilePerson, nationalityIncorrectEmail
}
